/* eslint-disable @typescript-eslint/no-explicit-any, jsdoc/require-returns */
/**
 * Throttle is used to execute the decorated method only once in a given time interval.
 * @param delay Time interval in milliseconds
 * @param keyFn Function that generates a dynamic key
 */
export function Throttle(delay, keyFn) {
    return function (_target, key, descriptor) {
        const originalMethod = descriptor.value;
        if (keyFn && keyFn.length > originalMethod.length) {
            console.error(`Throttle decorator keyFn argument list must match the decorated function.`);
        }
        descriptor.value = function (...args) {
            var _a, _b;
            this.__shouldWait = (_a = this.__shouldWait) !== null && _a !== void 0 ? _a : {};
            this.__waitingArgs = (_b = this.__waitingArgs) !== null && _b !== void 0 ? _b : {};
            const throttleKey = keyFn ? keyFn(...args) : key;
            const setTimeoutFn = () => {
                var _a;
                if ((_a = this.__waitingArgs) === null || _a === void 0 ? void 0 : _a[throttleKey]) {
                    originalMethod.call(this, ...this.__waitingArgs[throttleKey]);
                    this.__waitingArgs[throttleKey] = null;
                    setTimeout(setTimeoutFn, delay);
                }
                else {
                    if (!this.__shouldWait) {
                        this.__shouldWait = {};
                    }
                    this.__shouldWait[throttleKey] = false;
                }
            };
            if (this.__shouldWait[throttleKey]) {
                this.__waitingArgs[throttleKey] = args;
                return;
            }
            this.__shouldWait[throttleKey] = true;
            originalMethod.call(this, ...args);
            setTimeout(setTimeoutFn, delay);
        };
    };
}
